/**
 * 项目成员管理 API 调用
 */
import apiClient from '@/utils/apiClient';
import type {
  ProjectMember,
  AddProjectMembersRequest,
  UpdateProjectMemberRoleRequest,
  ApiResponse,
  AddProjectMembersResponse,
  GetProjectMembersResponse,
} from '@/types/project-member';

/**
 * 查询项目成员列表
 */
export async function getProjectMembers(
  projectId: string
): Promise<ApiResponse<GetProjectMembersResponse>> {
  return apiClient.get(`/project-members?project_id=${projectId}`);
}

/**
 * 查询虚拟项目成员列表（通过 entityType 和 entityId）
 * @param entityType - 虚拟项目类型：presale | contribution | other
 * @param entityId - 实体 ID（商机 ID / 专业贡献 ID / 部门 ID）
 */
export async function getVirtualProjectMembers(
  entityType: 'presale' | 'contribution' | 'other',
  entityId: string
): Promise<ApiResponse<GetProjectMembersResponse>> {
  return apiClient.get(`/project-members?entity_type=${entityType}&entity_id=${entityId}`);
}

/**
 * 批量添加成员
 */
export async function addProjectMembers(
  data: AddProjectMembersRequest
): Promise<ApiResponse<AddProjectMembersResponse>> {
  return apiClient.post('/project-members', data);
}

/**
 * 修改成员角色
 */
export async function updateProjectMemberRole(
  memberId: string,
  data: UpdateProjectMemberRoleRequest
): Promise<ApiResponse<ProjectMember>> {
  return apiClient.patch(`/project-members/${memberId}`, data);
}

/**
 * 移除成员
 */
export async function removeProjectMember(
  memberId: string
): Promise<ApiResponse<{ message: string }>> {
  return apiClient.delete(`/project-members/${memberId}`);
}
